import type { QuerySettings } from '@customTypes/index';
import { useQuery } from '@tanstack/react-query';

import type { ArtistGetProfileWorkHistoryRequest } from '@/features/artist/portfolio/api/profile-work-history/get/request';
import { artistGetProfileWorkHistory } from '@/features/artist/portfolio/api/profile-work-history/get/request';

export const useArtistProfileWorkHistoryQuery = (
  params: ArtistGetProfileWorkHistoryRequest,
  settings?: QuerySettings<typeof artistGetProfileWorkHistory>
) =>
  useQuery({
    queryKey: ['ArtistProfileWorkHistory', params.profileId],
    queryFn: () =>
      artistGetProfileWorkHistory({
        params,
        config: settings?.config
      }),
    ...settings?.options
  });
